function defaultMakeKeys(...args) {
  return args.join('--');
}
class HeaderCache {
  constructor(fetchFunction, makeKeys) {
    this.fetchFunction = fetchFunction;
    this.cache = {};
    this.makeKeys = makeKeys || defaultMakeKeys;
  }

  getMaxAge = res => {
    try {
      return res.headers
        .get('cache-control')
        .split(' ')
        .filter(key => key.includes('max-age'))[0]
        .split('=')[1];
    } catch (err) {
      return undefined;
    }
  };

  cacheTheResponse = ({ key, response, jsonResponse }) => {
    const maxAge = this.getMaxAge(response);
    if (!maxAge) {
      return;
    }
    const cacheObject = {
      expires: new Date(Date.now() + parseInt(maxAge, 10) * 1000),
      value: jsonResponse
    };
    this.cache[key] = cacheObject;
  };

  isValidResponse = cacheObject => {
    return Date.now() < cacheObject?.expires?.getTime();
  };

  getData = async (...args) => {
    const key = this.makeKeys(args);
    const cacheObject = this.cache[key];
    if (cacheObject && this.isValidResponse(cacheObject)) {
      return Promise.resolve(cacheObject.value);
    }
    try {
      const response = await this.fetchFunction(...args);
      if (!response.ok) {
        return Promise.reject(response);
      }
      const jsonResponse = await response.json();
      this.cacheTheResponse({ key, response, jsonResponse });
      return Promise.resolve(jsonResponse);
    } catch (err) {
      return Promise.reject(err);
    }
  };

  isCachedData = key => {
    const cacheObject = this.cache[key];
    if (cacheObject && this.isValidResponse(cacheObject)) {
      return cacheObject;
    }
    return false;
  };
}

export default HeaderCache;
